import $ from 'jquery';

$(function () {
    $('.faux-link').on('mouseenter', function () {
        $(this).closest('.has-faux-link').find('.button, .arrow').addClass('hover');
    });

    $('.faux-link').on('mouseleave', function () {
        $(this).closest('.has-faux-link').find('.button, .arrow').removeClass('hover');
    });

    $('.no-evt').on('click', function (evt) { evt.preventDefault(); });
});